// Unpublished Work © 2020 Deere & Company

import t from 'tcomb';

export const SaveError = t.struct({
    hasError: t.Boolean,
    errorMessage: t.String
}, {
    defaultProps: {
        hasError: false,
        errorMessage: ''
    },
    name: 'SaveError',
    strict: true
});
